import React from "react";
import { objToFormData } from "../../../helpers/FormHelper";
import { createYoutubeVideo } from "../../../actions/mine_craft/youtubeVideosActions";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { setNewError, setNewParams, YoutubeVideoInterface } from "../../../store/mine_craft/youtubeVideosSlice";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const New = () => {
  const dispatch  = useAppDispatch();
  const newParams = useAppSelector(state => state.mineCraft.youtubeVideos.newParams);
  const error     = useAppSelector(state => state.mineCraft.youtubeVideos.newError);

  function onCloseError() {
    dispatch(setNewError(null));
  }

  function onClose() {
    dispatch(setNewParams(null));
  }

  function onFinish(data: YoutubeVideoInterface) {
    const formData = objToFormData(data);
    handleSave(formData).catch(console.error);
  }

  async function handleSave(data: object) {
    const resultAction = await dispatch(createYoutubeVideo(data));

    if (createYoutubeVideo.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!newParams}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-new-youtubeVideo'>
        <h6 className="v-content-label">Create YoutubeVideo</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form onFinish={onFinish} params={newParams} />
      </div>
    </DrawerRight>
  )
}

export default New;
